import classNames from 'classnames'
import { getPbgidIcon, usePbgidIcons } from '../../helpers/pbgidIcons'

export function LiveGameMilitary({ pbgid, count, inQueue, isUnique = false, leftSide }) {
	const icon = getPbgidIcon(usePbgidIcons(), pbgid)

	return (
		<div className={classNames('liveGameOverlay__militaryUnitDiv w-[70px] h-[40px] flex', leftSide ? 'flex-row-reverse' : 'flex-row')}>
			<div className="w-[30px] bg-[#252525dc] flex flex-col">
				<h1
					className={classNames('h-5 px-1 text-[#b1b1b1] align-top -mt-[2px] italic', leftSide ? 'text-left' : 'text-right', inQueue === 0 ? 'opacity-0' : '')}
					style={{ textShadow: '2px 2px 3px black' }}>
					{inQueue}
				</h1>
				<h1
					className={classNames('h-5 px-1 text-white align-top -mt-[2px] text-[18px]', leftSide ? 'text-left' : 'text-right')}
					style={{ textShadow: '2px 2px 3px black' }}>
					{count}
				</h1>
			</div>
			<div
				className="w-[40px] relative"
				style={{
					backgroundImage: `url(/liveGameIcons/military_background.png)`,
				}}>
				<img className="w-10 h-10" src={icon} alt="" />
				{isUnique && <img className="absolute bottom-0 left-0 w-4 h-4" src={`/liveGameIcons/unique.png`} alt="" />}
			</div>
		</div>
	)
}
